import {Button, Layout, Tabs} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import CST from './CST';
import HealthcareT from './HealthcareT';
import PBT from './PBT';

const Content = Layout;

const ValidationTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);
  const [Tno, setTno] = useState(appColors['ColorX']);
  const [Gno, setGno] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTUno('white');
      setGUno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
    } else if (key === 'tres') {
      setTno('white');
      setGno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
    }
  };
  const items_ = [
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Public Health</Button>, key: 'uno', children: <HealthcareT/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Healthcare</Button>, key: 'dos', children: <PBT/>},
    {label: <Button style={{width: '22vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: Tno, fontWeight: 'bold', borderColor: Gno, background: Gno}}>Civil Society</Button>, key: 'tres', children: <CST/>},
  ];
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='3vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default ValidationTabs;
